import { useState, useEffect } from "react";
import Header from "../../header/Header";
import FadeIn from "../../../general/FadeIn";
import RoundedInput from "../../../general/RoundedInput";
import DateInput from "../../../general/DateInput";
import OrangeButton from "../../../general/OrangeButton";
import JazigoModal from "../../../general/JazigoModal";
import DocumentUploader from "../../../general/DocumentUploader";
import Api from "../../../../services/Api";

const labelStyle = {
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 13,
  fontWeight: 600,
  color: "#888",
  marginBottom: 4,
  paddingLeft: 12,
  display: "block",
};

const sectionTitleStyle = {
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 15,
  fontWeight: 700,
  color: "#555",
  marginBottom: 4,
  marginTop: 8,
};

const inputBase = {
  width: "100%",
  padding: "16px 28px",
  borderRadius: 40,
  border: "none",
  background: "#e8e8e8",
  fontSize: 16,
  fontFamily: "'DM Sans', sans-serif",
  color: "#666",
  outline: "none",
  boxSizing: "border-box",
  cursor: "pointer",
  textAlign: "left",
};

function RegisterBurialPage({ navigate, user, onLogout }) {
  const [falecidoForm, setFalecidoForm] = useState({
    nome_completo: "",
    apelido: "",
    data_nascimento: "",
    data_falecimento: "",
    nome_pai: "",
    nome_mae: "",
    causa_morte: "",
    medico_responsavel: "",
    registrado: false,
    mensagem_familia: "",
    observacoes: "",
  });
  const [burialForm, setBurialForm] = useState({
    jazigo_id: null,
    data_sepultamento: "",
    funeraria: "",
    responsavel_sepultamento: "",
    ordem_no_jazigo: "",
  });
  const [jazigos, setJazigos] = useState([]);
  const [jazigoModalOpen, setJazigoModalOpen] = useState(false);
  const [selectedJazigo, setSelectedJazigo] = useState(null);
  const [vagasInfo, setVagasInfo] = useState(null);
  const [loadingVagas, setLoadingVagas] = useState(false);
  const [popupError, setPopupError] = useState("");
  const [loading, setLoading] = useState(false);
  const [docFile, setDocFile] = useState(null);
  const [outrosDocs, setOutrosDocs] = useState([]);
  const [outrosDocsDescricoes, setOutrosDocsDescricoes] = useState([]);

  useEffect(() => {
    Api.getJazigos()
      .then((geojson) =>
        setJazigos(
          geojson.features.map((f) => ({
            id: f.properties.id,
            codigo: f.properties.numero,
            quadra: f.properties.quadra,
          })),
        ),
      )
      .catch(() => {});
  }, []);

  const updateFalecido = (field) => (e) =>
    setFalecidoForm((prev) => ({ ...prev, [field]: e.target.value }));

  const updateBurial = (field) => (e) =>
    setBurialForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = async () => {
    if (
      !falecidoForm.nome_completo ||
      !falecidoForm.data_falecimento ||
      !burialForm.jazigo_id ||
      !burialForm.data_sepultamento
    ) {
      setPopupError(
        "Nome completo, data de falecimento, jazigo e data de sepultamento são obrigatórios.",
      );
      return;
    }
    setLoading(true);
    try {
      const falecidoCriado = await Api.createBuried({
        nome_completo: falecidoForm.nome_completo,
        data_nascimento: falecidoForm.data_nascimento || null,
        data_falecimento: falecidoForm.data_falecimento,
        nome_pai: falecidoForm.nome_pai || null,
        nome_mae: falecidoForm.nome_mae || null,
        apelido: falecidoForm.apelido || null,
        causa_morte: falecidoForm.causa_morte || null,
        medico_responsavel: falecidoForm.medico_responsavel || null,
        registrado: true,
        mensagem_familia: falecidoForm.mensagem_familia || null,
        observacoes: falecidoForm.observacoes || null,
      });
      await Api.createBurial({
        falecido_id: falecidoCriado.id,
        jazigo_id: burialForm.jazigo_id,
        data_sepultamento: burialForm.data_sepultamento,
        responsavel_sepultamento: burialForm.responsavel_sepultamento || null,
        funeraria: burialForm.funeraria || null,
        ordem_no_jazigo: burialForm.ordem_no_jazigo
          ? Number(burialForm.ordem_no_jazigo)
          : null,
      });
      if (docFile) {
        await Api.uploadFalecidoDoc(
          falecidoCriado.id,
          docFile,
          "Certidão de Óbito",
          "Foto da certidão de óbito",
        );
      }
      for (let i = 0; i < outrosDocs.length; i++) {
        const tipo = outrosDocsDescricoes[i]?.trim() || undefined;
        await Api.uploadFalecidoDoc(falecidoCriado.id, outrosDocs[i], tipo);
      }
      navigate("search", { selectedFalecido: falecidoCriado });
    } catch (e) {
      setPopupError(e.message || "Erro ao cadastrar.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#fafafa",
      }}
    >
      {popupError && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 14,
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              padding: "32px 36px",
              maxWidth: 380,
              width: "90%",
              textAlign: "center",
            }}
          >
            <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
            <h3
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 18,
                fontWeight: 700,
                color: "#2d2d2d",
                marginBottom: 10,
              }}
            >
              Erro ao cadastrar
            </h3>
            <p
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 15,
                color: "#666",
                marginBottom: 24,
              }}
            >
              {popupError}
            </p>
            <button
              onClick={() => setPopupError("")}
              style={{
                background: "linear-gradient(135deg, #F2A66C 0%, #E8956A 100%)",
                border: "none",
                color: "#fff",
                borderRadius: 8,
                padding: "10px 28px",
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 15,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Fechar
            </button>
          </div>
        </div>
      )}
      <JazigoModal
        isOpen={jazigoModalOpen}
        onClose={() => setJazigoModalOpen(false)}
        jazigos={jazigos}
        onSelect={(j) => {
          setSelectedJazigo(j);
          setBurialForm((prev) => ({ ...prev, jazigo_id: j.id }));
          setVagasInfo(null);
          setLoadingVagas(true);
          Promise.all([Api.getJazigo(j.id), Api.getJazigoFalecidosAtivos(j.id)])
            .then(([jaz, ativos]) =>
              setVagasInfo({ capacidade: jaz.capacidade, ocupadas: ativos.length }),
            )
            .catch(() => setVagasInfo(null))
            .finally(() => setLoadingVagas(false));
        }}
      />
      <Header
        onHome={() => navigate("search")}
        onLogin={() => navigate("login")}
        user={user}
        onLogout={onLogout}
        navigate={navigate}
      />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
        }}
      >
        <FadeIn delay={100}>
          <h1
            style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 32,
              fontWeight: 700,
              color: "#2d2d2d",
              textAlign: "center",
              marginBottom: 36,
            }}
          >
            Cadastrar Óbito e Sepultamento
          </h1>
        </FadeIn>

        <div
          style={{
            width: "100%",
            maxWidth: 400,
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}
        >
          <FadeIn delay={160}>
            <p style={sectionTitleStyle}>Dados do Falecido</p>
            <hr
              style={{
                border: "none",
                borderTop: "1px solid #e0e0e0",
                marginBottom: 8,
              }}
            />
          </FadeIn>

          <FadeIn delay={200}>
            <RoundedInput
              placeholder="Nome completo *"
              value={falecidoForm.nome_completo}
              onChange={updateFalecido("nome_completo")}
            />
          </FadeIn>

          <FadeIn delay={260}>
            <RoundedInput
              placeholder="Apelido"
              value={falecidoForm.apelido}
              onChange={updateFalecido("apelido")}
            />
          </FadeIn>

          <FadeIn delay={320}>
            <div lang="pt-BR">
              <label style={labelStyle}>Data de nascimento</label>
              <DateInput
                value={falecidoForm.data_nascimento}
                onChange={updateFalecido("data_nascimento")}
              />
            </div>
          </FadeIn>

          <FadeIn delay={380}>
            <div lang="pt-BR">
              <label style={labelStyle}>Data de falecimento *</label>
              <DateInput
                value={falecidoForm.data_falecimento}
                onChange={updateFalecido("data_falecimento")}
              />
            </div>
          </FadeIn>

          <FadeIn delay={440}>
            <RoundedInput
              placeholder="Nome do pai"
              value={falecidoForm.nome_pai}
              onChange={updateFalecido("nome_pai")}
            />
          </FadeIn>

          <FadeIn delay={500}>
            <RoundedInput
              placeholder="Nome da mãe"
              value={falecidoForm.nome_mae}
              onChange={updateFalecido("nome_mae")}
            />
          </FadeIn>

          <FadeIn delay={560}>
            <RoundedInput
              placeholder="Causa da morte"
              value={falecidoForm.causa_morte}
              onChange={updateFalecido("causa_morte")}
            />
          </FadeIn>

          <FadeIn delay={620}>
            <RoundedInput
              placeholder="Médico responsável"
              value={falecidoForm.medico_responsavel}
              onChange={updateFalecido("medico_responsavel")}
            />
          </FadeIn>

          <FadeIn delay={680}>
            <RoundedInput
              placeholder="Observações"
              value={falecidoForm.observacoes}
              onChange={updateFalecido("observacoes")}
            />
          </FadeIn>
          <FadeIn delay={740}>
            <div style={{ marginTop: 8 }}>
              <label style={labelStyle}>Foto da certidão de óbito</label>

              <label
                htmlFor="falecido-doc-upload"
                style={{
                  width: "100%",
                  minHeight: 90,
                  borderRadius: 24,
                  border: "2px dashed #d0d0d0",
                  background: "#f4f4f4",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  padding: 20,
                  boxSizing: "border-box",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <div style={{ fontSize: 28 }}>📄</div>

                  <span
                    style={{
                      fontFamily: "'DM Sans', sans-serif",
                      fontSize: 14,
                      color: docFile ? "#555" : "#999",
                      textAlign: "center",
                      wordBreak: "break-word",
                    }}
                  >
                    {docFile ? docFile.name : "Clique para enviar um documento"}
                  </span>
                </div>
              </label>

              <input
                id="falecido-doc-upload"
                type="file"
                accept=".jpg,.jpeg,.png"
                style={{ display: "none" }}
                onChange={(e) => {
                  const file = e.target.files?.[0];

                  if (file) {
                    setDocFile(file);
                  }
                }}
              />
            </div>
          </FadeIn>

          <FadeIn delay={770}>
            <DocumentUploader
              inputId="falecido-outros-docs-upload"
              label="Outros documentos do falecido"
              files={outrosDocs}
              onChange={setOutrosDocs}
              descricoes={outrosDocsDescricoes}
              onDescricoesChange={setOutrosDocsDescricoes}
            />
          </FadeIn>

          <FadeIn delay={800}>
            <p style={{ ...sectionTitleStyle, marginTop: 16 }}>
              Dados do Sepultamento
            </p>
            <hr
              style={{
                border: "none",
                borderTop: "1px solid #e0e0e0",
                marginBottom: 8,
              }}
            />
          </FadeIn>

          <FadeIn delay={860}>
            <button
              type="button"
              onClick={() => setJazigoModalOpen(true)}
              style={{
                ...inputBase,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span style={{ color: selectedJazigo ? "#444" : "#bbb" }}>
                {selectedJazigo ? `Setor: ${selectedJazigo.quadra} - Número: ${selectedJazigo.codigo}` : "Selecionar jazigo *"}
              </span>
              <svg
                width="14"
                height="14"
                viewBox="0 0 12 12"
                fill="none"
                style={{ flexShrink: 0 }}
              >
                <path
                  d="M2 4l4 4 4-4"
                  stroke="#aaa"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </FadeIn>

          <FadeIn delay={920}>
            <div lang="pt-BR">
              <label style={labelStyle}>Data do Sepultamento *</label>
              <DateInput
                value={burialForm.data_sepultamento}
                onChange={updateBurial("data_sepultamento")}
              />
            </div>
          </FadeIn>

          <FadeIn delay={980}>
            <div lang="pt-BR">
              <RoundedInput
                placeholder="Funerária responsável"
                type="text"
                value={burialForm.funeraria}
                onChange={updateBurial("funeraria")}
              />
            </div>
          </FadeIn>

          <FadeIn delay={1040}>
            <RoundedInput
              placeholder="Responsável pelo sepultamento"
              value={burialForm.responsavel_sepultamento}
              onChange={updateBurial("responsavel_sepultamento")}
            />
          </FadeIn>

          <FadeIn delay={1100}>
            <RoundedInput
              placeholder="Ordem no jazigo"
              type="number"
              value={burialForm.ordem_no_jazigo}
              onChange={updateBurial("ordem_no_jazigo")}
            />
          </FadeIn>

          <FadeIn delay={1160}>
            <div style={{ textAlign: "center", marginTop: 20 }}>
              <OrangeButton onClick={handleSubmit} disabled={loading}>
                {loading ? "Cadastrando..." : "Cadastrar"}
              </OrangeButton>

              <p
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: 13,
                  color: "#999",
                  marginTop: 12,
                }}
              >
                (* Campos obrigatórios)
              </p>
              <p
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: 14,
                  color: "#E8956A",
                  marginTop: 16,
                  cursor: "pointer",
                }}
                onClick={() => navigate("search")}
              >
                Voltar para a busca
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </div>
  );
}

export default RegisterBurialPage;
